export const defaultProps = {
	delayTime: 0.6,
	wetDryRatio: 0.5,
};

export type Props = typeof defaultProps;
